module.exports = __webpack_public_path__ + "img/swift-booster-green-amarillo-ocaso.7ebc7d34.png";